import { List } from "immutable";
import React from "react";
import { Media } from "@domain/media/media";
import { ClosableModal } from "@ui/modals/closableModal";
import { AssetBrowser } from "./assetBrowser";

interface AssetBrowserModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: (assets?: List<Media>) => void;
	allowedTypes?: string[];
	multiple?: boolean;
}
export const AssetBrowserModal: React.FC<AssetBrowserModalProps> = ({
	allowedTypes,
	close,
	multiple,
	...htmlProps
}) => {
	return (
		<ClosableModal {...htmlProps} close={() => close()}>
			<AssetBrowser onAssetsChosen={(asset) => close(asset)} allowedTypes={allowedTypes} multiple={multiple} />
		</ClosableModal>
	);
};
